import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem, Chip, Stack} from '@mui/material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


const RMeditablerow = ({k,row, subject, editFormData, handleCancelClick,
   page, rowsPerPage, onChangeEditCateg, assetCategory, assetmaster}) =>{
    console.log(subject.subjectIndex)
    console.log(editFormData)
    console.log(editFormData[`Subject${k}`][subject.subjectIndex])
    return( <>
        <TableRow key={k} name={row.Category}>
           <TableCell component="th" scope="row">
           {(page)*(rowsPerPage)+k+1}
           </TableCell>
           
        <TableCell  align="left">
          <input
            name = {"Category"+`${(page)*(rowsPerPage)+k}`}
            // {...register("Category"+`${k}`, {maxLength: 20})}
            // type="text"
            // required="required"
            value= {editFormData[`Category${(page)*(rowsPerPage)+k}`]}
            onChange={onChangeEditCateg}
          ></input>
        </TableCell>
        <TableCell  align="left">
          {(subject.subjectValue[k] === "") || (subject.subjectValue[k] === undefined) ? "Select"
         :
          (<input
              name = {"Subject"+`${(page)*(rowsPerPage)+k}`}
              // {...register("Subject"+`${k}`, {maxLength: 20})}
              // type="text"
              // required="required"
              // placeholder="Enter a Sub Category"
              value= {editFormData[`Subject${(page)*(rowsPerPage)+k}`][subject.subjectIndex]}
              onChange={onChangeEditCateg}
            ></input>)}         

            </TableCell>           

            <TableCell align="left">
              <button style={{marginRight:'10px'}} type="submit">Save</button>
              <button style={{marginRight:'10px'}} type="button" onClick={(e)=>handleCancelClick(e,k)}
              >Cancel</button>                          
            </TableCell>
          </TableRow>     
        </>         
    )
}

export default RMeditablerow;